import { render } from "./Hok.vue?vue&type=template&id=96ffff90&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./Hok.vue?vue&type=script&lang=ts"
export * from "./Hok.vue?vue&type=script&lang=ts"

import "./Hok.vue?vue&type=style&index=0&id=96ffff90&scoped=true&lang=css"
import "./Hok.vue?vue&type=style&index=1&id=96ffff90&lang=css"
import "./Hok.vue?vue&type=style&index=2&id=96ffff90&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ffff90"]])

export default __exports__